(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["nox-delivery-estimate"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nox-delivery')) {
    const REG = {
      Sudeste: { min: 3, max: 5, estados: 'SP · RJ · MG · ES', ufs: ['SP', 'RJ', 'MG', 'ES'] },
      Sul: { min: 4, max: 7, estados: 'PR · SC · RS', ufs: ['PR', 'SC', 'RS'] },
      'Centro-Oeste': { min: 4, max: 7, estados: 'GO · MT · MS · DF', ufs: ['GO', 'MT', 'MS', 'DF'] },
      Nordeste: { min: 5, max: 8, estados: 'BA · PE · CE · MA e demais', ufs: ['BA', 'SE', 'PE', 'AL', 'PB', 'RN', 'CE', 'PI', 'MA'] },
      Norte: { min: 7, max: 10, estados: 'AM · PA · AC · RO e demais', ufs: ['PA', 'AM', 'RR', 'AP', 'AC', 'RO', 'TO'] },
    };
    const CEP_UF = [[1000,19999,'SP'],[20000,28999,'RJ'],[29000,29999,'ES'],[30000,39999,'MG'],[40000,48999,'BA'],[49000,49999,'SE'],[50000,56999,'PE'],[57000,57999,'AL'],[58000,58999,'PB'],[59000,59999,'RN'],[60000,63999,'CE'],[64000,64999,'PI'],[65000,65999,'MA'],[66000,68899,'PA'],[68900,68999,'AP'],[69000,69299,'AM'],[69300,69399,'RR'],[69400,69899,'AM'],[69900,69999,'AC'],[70000,72799,'DF'],[72800,76799,'GO'],[76800,76999,'RO'],[77000,77999,'TO'],[78000,78999,'MT'],[79000,79999,'MS'],[80000,87999,'PR'],[88000,89999,'SC'],[90000,99999,'RS']];
    const regionOf = (uf) => Object.entries(REG).find(([, r]) => r.ufs.includes(uf));
    const ufFromCep = (cep) => {
      const n = parseInt(cep.slice(0, 5), 10);
      const hit = CEP_UF.find(([a, b]) => n >= a && n <= b);
      return hit ? hit[2] : null;
    };

    class NoxDelivery extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('.nox-deliv__input');
        this.btn = this.querySelector('.nox-deliv__btn');
        this.out = this.querySelector('.nox-deliv__result');
        this.tpl = this.querySelector('.nox-deliv__tpl');
        this.input.addEventListener('input', () => {
          const v = this.input.value.replace(/\D/g, '').slice(0, 8);
          this.input.value = v.length > 5 ? `${v.slice(0, 5)}-${v.slice(5)}` : v;
          this.input.classList.remove('is-error');
          if (!v) this.out.replaceChildren();
        });
        this.querySelector('form').addEventListener('submit', (event) => {
          event.preventDefault();
          this.calc();
        });
        try {
          const saved = localStorage.getItem('nox-cep');
          if (saved && saved.length === 8) {
            this.input.value = `${saved.slice(0, 5)}-${saved.slice(5)}`;
            this.calc();
          }
        } catch (e) {}
      }

      message(text, error) {
        const p = document.createElement('p');
        p.className = `nox-deliv__msg${error ? ' nox-deliv__msg--error' : ''}`;
        p.textContent = text;
        this.out.replaceChildren(p);
      }

      show(uf, cep, street) {
        const found = regionOf(uf);
        if (!found) {
          this.message('Não conseguimos identificar a região. Fale com a gente pelo chat.', true);
          return;
        }
        const [name, r] = found;
        const node = this.tpl.content.cloneNode(true);
        node.querySelector('[data-f="regiao"]').textContent = name;
        node.querySelector('[data-f="local"]').textContent = `${street ? `${street} — ` : ''}${cep.slice(0, 5)}-${cep.slice(5)}`;
        node.querySelector('[data-f="estados"]').textContent = r.estados;
        node.querySelector('[data-f="dias"]').textContent = `${r.min}–${r.max}`;
        this.out.replaceChildren(node);
        try {
          localStorage.setItem('nox-cep', cep);
        } catch (e) {}
      }

      async calc() {
        const cep = this.input.value.replace(/\D/g, '');
        if (cep.length !== 8) {
          this.input.classList.add('is-error');
          this.message('CEP inválido. Digite os 8 números, por exemplo 01310-100.', true);
          this.input.focus();
          return;
        }
        this.btn.disabled = true;
        this.message('Consultando CEP...');
        try {
          const res = await fetch(`https://viacep.com.br/ws/${cep}/json/`);
          const data = await res.json();
          if (data.erro) {
            this.input.classList.add('is-error');
            this.message('CEP não encontrado. Confira os números e tente de novo.', true);
          } else {
            const street = [data.logradouro, data.bairro].filter(Boolean).join(', ');
            this.show(data.uf, cep, street);
          }
        } catch (e) {
          const uf = ufFromCep(cep);
          if (uf) this.show(uf, cep, '');
          else this.message('Não foi possível consultar o CEP agora. Tente de novo ou fale pelo chat.', true);
        } finally {
          this.btn.disabled = false;
        }
      }
    }
    customElements.define('nox-delivery', NoxDelivery);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["nox-tier-offer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nox-offer')) {
    class NoxOffer extends HTMLElement {
      connectedCallback() {
        this.onCart = (event) => {
          Promise.resolve(event && event.promise).catch(() => {}).then(() => this.refresh());
        };
        document.addEventListener('shopify:cart:lines-update', this.onCart);
      }
      disconnectedCallback() {
        document.removeEventListener('shopify:cart:lines-update', this.onCart);
      }
      async refresh() {
        try {
          const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
          const cart = await res.json();
          const n = cart.items
            .filter((item) => !String(item.handle || '').startsWith('lampada-'))
            .reduce((sum, item) => sum + item.quantity, 0);
          this.render(n);
        } catch (e) {}
      }
      render(n) {
        const reach = Math.min(n, 3);
        this.querySelectorAll('[data-step]').forEach((li) => {
          if (Number(li.dataset.step) === reach) li.setAttribute('aria-current', 'step');
          else li.removeAttribute('aria-current');
        });
        const hint = this.querySelector('[data-hint]');
        if (hint) hint.textContent = this.dataset['hint-' + Math.min(n, 3)] ?? this.getAttribute('data-hint-' + Math.min(n, 3));
        this.dataset.count = String(n);
      }
    }
    customElements.define('nox-offer', NoxOffer);
  }
  } catch(e) { console.error(e); }
})();

})();
